import { ItemSuggestionCardProps } from './interfaces';
import PromotionProduct from './PromotionProduct';
import SimpleProduct from './SimpleProduct';

export default function ItemSuggestionCard({
	posId,
	promotionData,
	simpleProductData,
	selectedDistributor,
	updateSummary,
	promotionHandlers,
	onAfterReplaceSourceProduct
}: ItemSuggestionCardProps) {
	if (promotionData && selectedDistributor && promotionHandlers && simpleProductData)
		return (
			<PromotionProduct
				data={promotionData}
				posId={posId}
				updateSummary={updateSummary!}
				promotionHandlers={promotionHandlers}
				simpleProductData={simpleProductData}
				selectedDistributor={selectedDistributor}
				onAfterReplaceSourceProduct={onAfterReplaceSourceProduct!}
			/>
		);

	return <SimpleProduct data={simpleProductData!} />;
}
